import {fromEvent, MonoTypeOperatorFunction} from 'rxjs';
import {auditByBooleanState} from 'util/rxjsOperators/auditByBooleanState';

const overrideState = {active: false, hidden: false}

export function _overrideDocumentHidden(hidden: boolean | null) {
	if (hidden === null) overrideState.active = false;
	else {
		overrideState.active = true;
		overrideState.hidden = hidden;
	}
}

export function auditDocumentVisible<T>(): MonoTypeOperatorFunction<T> {
	return auditByBooleanState<T>(
		() => overrideState.active ? !overrideState.hidden : !document.hidden,
		fromEvent<T>(document, 'visibilitychange'),
	)
}